import type { Camp } from '@/types/database'
import type { CampData } from '@/store/reducer'
import { serializeCampContext } from './ai-service'

export function buildChatSystemPrompt(camp: Camp, campData: CampData, activeTab?: string): string {
  const campContext = serializeCampContext(camp, campData, activeTab)

  return `あなたは「atsume.camp」の団体旅行プランニングAIアシスタントです。

## 役割
- PMの業務をサポートする専門アシスタント
- 日本国内の団体旅行（10-100人規模）の知識を持つ
- 旅行手配、見積もり、参加者管理、支払いスケジュールに精通

## 現在の案件コンテキスト
${campContext}

## 応答ルール
- 日本語で応答する
- 具体的で実行可能な提案をする
- 金額は円単位で表示する
- 質問されたタブの内容に関連する回答を優先する
- マークダウン形式で見やすく整理する
- 不明な点があれば確認する`
}
